<template>
  <div class="headerWrapper">
    <i v-if="leftIcon"
      class="icon iconfont left"
      v-tap
      @tap="goBack()">&#xe604;</i>
    {{title}}
    <i v-if="rightIcon"
      class="icon iconfont right">&#xe632;</i>
    <i v-if="selfRightIcon1"
      class="icon iconfont right"
      v-tap
      @tap="order"
      v-html="selfRightIcon1"></i>
    <i v-if="selfRightIcon2&&selfRightIcon2Value"
      class="icon iconfont right2"
      v-tap
      @tap="select(title)"
      v-html="selfChoiceHeader"></i>
    <i v-if="selfRightIcon2&&!selfRightIcon2Value"
      class="icon iconfont right2"
      v-tap
      @tap="select(title)"
      v-html="selfChoiceHeader2"></i>

    <!--<div>{{selfChoiceHeader}}</div>-->
  </div>
</template>

<script>
import front from "../../../static/js/proto/CtpFront.js";

export default {
  name: "yjheader",
  props: [
    "leftIcon",
    "title",
    "rightIcon",
    "selfRightIcon1",
    "selfRightIcon2",
    "selfChoiceHeader"
  ],
  data() {
    return {
      selfRightIcon2Value: true,
      selfChoiceHeader2: ""
    };
  },
  methods: {
    // appAlrClose:function () {
    //
    //
    // },

    goBack() {
      window.history.back();
    },
    order() {
      this.$router.push({ path: "/tradeDetail/0" });
      localStorage.contractorNo = this.title;
    },
    //添加自选股
    select(item) {
      if (
        this.selfChoiceHeader == "&#xe63c;" ||
        this.selfChoiceHeader2 == "&#xe63c;"
      ) {
        front.selectedTargetAdd(
          item,
          resolve => {
            this.selfRightIcon2Value = false;
            this.selfChoiceHeader2 = "&#xe617;";
            // console.log(resolve);
            // alert(1)
          },
          reject => {
            // console.log(reject);
            // alert(2)
            this.selfRightIcon2Value = false;
            this.selfChoiceHeader2 = "&#xe617;";
          }
        );
      } else if (
        this.selfChoiceHeader == "&#xe617;" ||
        this.selfChoiceHeader2 == "&#xe617;"
      ) {
        front.selectedTargetRemove(
          item,
          resolve => {
            this.selfRightIcon2Value = false;
            this.selfChoiceHeader2 = "&#xe63c;";
            // console.log(resolve);
            // alert(3)
          },
          reject => {
            // console.log(reject);
            this.selfRightIcon2Value = false;
            this.selfChoiceHeader2 = "&#xe63c;";
            // alert(4)
          }
        );
      }
    }
  }
};
</script>

<style scoped>
.iconfont {
  font-family: "iconfont" !important;
  font-size: 0.32rem;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

.headerWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 1rem;
  padding: 0 1.2rem;
  box-sizing: border-box;
  text-align: center;
  background: linear-gradient(90deg, #111822 0%, #141b1f 100%);
  color: #f4f7fb;
  font-size: 0.36rem;
  font-weight: 600;
  letter-spacing: 0.01rem;
  border-bottom: 1px solid rgba(58, 68, 82, 0.9);
  box-shadow: 0 0.06rem 0.18rem rgba(0, 0, 0, 0.16);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left {
  position: absolute;
  left: 0.08rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 0.34rem;
  color: #d9e2ec;
}

.right {
  position: absolute;
  right: 0.16rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0.72rem;
  text-align: center;
  font-size: 0.34rem;
  color: #d9e2ec;
}

.right2 {
  position: absolute;
  right: 0.76rem;
  top: 50%;
  transform: translateY(-50%);
  width: 0.72rem;
  text-align: center;
  font-size: 0.34rem;
  color: #d9e2ec;
}

.nav-mobile-button {
  position: relative;
  float: right;
  padding: 9px 10px;
  margin-top: 8px;
  margin-right: 15px;
  margin-bottom: 8px;
  background-color: transparent;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
  background: #eee;
}

.nav-mobile-button .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.nav-mobile-button .icon-bar {
  display: block;
  margin-top: 4px;
  width: 22px;
  height: 2px;
  background: #f65d3f;
  border-radius: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/yjheader.vue